module.exports = __webpack_public_path__ + "static/assets/768e176ca27319877e38f56c40eea680.svg";